import type { components } from '@fluencelabs/vodopad-admin-api'

import client from '@/api/client'
import { createByIdsCache } from '@/hooks/createByIdsCache'

type AdminUserVmDto = components['schemas']['AdminUserVmDto']

const vmsCache = createByIdsCache<AdminUserVmDto>({
  queryKeyPrefix: 'vmsByIds',
  fetcher: async (ids) => {
    const res = await client.GET('/v2/admin/vms', {
      params: { query: { ids: [...ids], page: 1, perPage: ids.length } },
    })
    return res.data?.items ?? []
  },
  getId: (vm) => vm.id,
})

export const useVmsByIds = vmsCache.useByIds
export const useVmsCache = vmsCache.useCache
export const VmsCacheProvider = vmsCache.Provider
